export const searchDropdown =  [
	{
	  title: "Discounts Name",
	  value: "discounts.name"
	}
]


// WEBPACK FOOTER //
// ./src/pages/discounts/filter/searchDropdown.js